module.exports = __webpack_public_path__ + "img/freddie at hillcrest dorm party.efe9025a.png";